module.exports = __webpack_public_path__ + "img/luxembourg.ec775866.svg";